import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type AddModelResultFragment = { __typename: 'Model', id: string, legacyId: number };

export type CreateModelMutationVariables = Types.Exact<{
  input: Types.MutationCreateModelInput;
}>;


export type CreateModelMutation = { __typename: 'Mutation', createModel: { __typename: 'Model', id: string, legacyId: number } };

export const AddModelResultFragmentDoc = gql`
    fragment AddModelResult on Model {
  id
  legacyId
}
    `;
export const CreateModelDocument = gql`
    mutation createModel($input: MutationCreateModelInput!) {
  createModel(input: $input) {
    ...AddModelResult
  }
}
    ${AddModelResultFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateModelGQL extends Apollo.Mutation<CreateModelMutation, CreateModelMutationVariables> {
    override document = CreateModelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }